import React from "react";
import PropTypes from "prop-types";
import BulkAssignDialog from "./BulkAssignDialog";
import BulkDeleteTasksDialog from "./BulkDeleteTasksDialog";
import ModelTaskDeleteDialog from "./ModelTaskDeleteDialog";

const ModelTaskDialogs = ({
	taskPendingDeletion,
	taskCaption,
	deleteEndpoint,
	onCloseDeleteDialog,
	onDeleted,
	showSelection,
	assign,
	applyAssign,
	taskCaptionPlural,
	customCaptions,
	bulkDeleteOpen,
	selectedTasks,
	isDeleting,
	onCloseBulkDelete,
	onConfirmBulkDelete,
}) => (
	<>
		<ModelTaskDeleteDialog
			taskId={taskPendingDeletion}
			taskCaption={taskCaption}
			deleteEndpoint={deleteEndpoint}
			onClose={onCloseDeleteDialog}
			onDeleted={onDeleted}
		/>
		{showSelection && (
			<BulkAssignDialog
				relation={assign.relation}
				summary={assign.summary}
				isLoading={assign.isLoading}
				isSaving={assign.isSaving}
				taskCaptionPlural={taskCaptionPlural}
				customCaptions={customCaptions}
				onClose={assign.close}
				onApply={applyAssign}
			/>
		)}
		{showSelection && (
			<BulkDeleteTasksDialog
				open={bulkDeleteOpen}
				tasks={selectedTasks}
				taskCaption={taskCaption}
				taskCaptionPlural={taskCaptionPlural}
				isDeleting={isDeleting}
				onClose={onCloseBulkDelete}
				onConfirm={onConfirmBulkDelete}
			/>
		)}
	</>
);

ModelTaskDialogs.propTypes = {
	taskPendingDeletion: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	taskCaption: PropTypes.string,
	deleteEndpoint: PropTypes.string.isRequired,
	onCloseDeleteDialog: PropTypes.func.isRequired,
	onDeleted: PropTypes.func.isRequired,
	showSelection: PropTypes.bool.isRequired,
	assign: PropTypes.shape({
		relation: PropTypes.object,
		summary: PropTypes.object,
		isLoading: PropTypes.bool,
		isSaving: PropTypes.bool,
		close: PropTypes.func.isRequired,
	}).isRequired,
	applyAssign: PropTypes.func.isRequired,
	taskCaptionPlural: PropTypes.string,
	customCaptions: PropTypes.object,
	bulkDeleteOpen: PropTypes.bool.isRequired,
	selectedTasks: PropTypes.array.isRequired,
	isDeleting: PropTypes.bool,
	onCloseBulkDelete: PropTypes.func.isRequired,
	onConfirmBulkDelete: PropTypes.func.isRequired,
};

export default ModelTaskDialogs;
